import Tooltip, { type TooltipProps } from "./Tooltip";
export { Tooltip as default, Tooltip, TooltipProps };